export function getCookieByName(CookieName) {
    return document.cookie.match('(^|;)\\s*' + CookieName + '\\s*=\\s*([^;]+)')?.pop() || '';
}

export function setCookie(cookieName, value, expires) {
    document.cookie = `${cookieName}=${value}; path=/; expires=${expires}`;
}